import { PropsWithChildren } from 'react'
import './SectionBox.scss'

interface SectionBoxProps {
    title: string
    className?: any
}

const SectionBox = ({ title, children, className }: PropsWithChildren<SectionBoxProps>) => {
    return (
        <div className={`smart-modals-activity-section-box ${className || ''}`}>
            <div className="smart-modals-activity-section-box__title">{title}</div>
            {children}
        </div>
    )
}

export default SectionBox
